module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app",
      "data-route": _vm.$route.name
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.transition
    },
    on: {
      "enter": function($event) {
        _vm.entering = true
      },
      "after-leave": function($event) {
        _vm.entering = false
      }
    }
  }, [_c('keep-alive', [_c('router-view', {
    attrs: {
      "currentData": _vm.current,
      "projects": _vm.projects,
      "info": _vm.info,
      "entering": _vm.entering,
      "savedPosition": _vm.savedPosition
    }
  })], 1)], 1), _c('vue-progress-bar')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 149
// module chunks = 1